import React from "react";
import classNames from "../classNames";

function RadioGroup({
  label,
  name,
  options,
  value,
  onChange,
  field,
  required,
  className,
}) {
  return (
    <div className="radio-group d-flex flex-column">
      {label && <p className="mb-2 fw-bold">{label}</p>}
      {options.map((option) => (
        <div
          key={option.value}
          className={`d-flex gap-2 rounded-3 mb-2 ${
            value === option.value ? "fw-bold" : "fw-light"
          }`}
          style={{ cursor: "pointer", transition: "all 0.2s ease" }}
          onClick={() => onChange(option.value, field)}
        >
          <input
            className={classNames("form-check-input", className)}
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value, field)}
            id={`${name}-${option.value}`}
            required={required}
          />
          <label
            className="form-check-label"
            htmlFor={`${name}-${option.value}`}
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}

export default RadioGroup;
